'use strict'

import debounce from './debounce.js'
import equalheightgridrows from './equalheightgridrows.js'

// requires jQuery on page
export default debounce(function () {
  // All the taxing stuff you do
  // equalheightgridrows($('.card-deck .card-body'))
  equalheightgridrows($('#memberships .ul--triangles'))
  equalheightgridrows($('#online-memberships .ul--triangles'))
  equalheightgridrows($('.row-contact-detail > div'))
}, 300)
